import {Application} from '@hotwired/stimulus';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
import '@hotwired/turbo-rails'
import BookingController from './controllers/booking_controller';
import AddressController from './controllers/address_controller';
import UserPaymentsController from './controllers/user_payments_controller';
import OutstandingBalanceController from './controllers/outstanding_balance';
import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false

// Stimulus controllers
window.Stimulus = Application.start();
Stimulus.register('booking', BookingController);
Stimulus.register('address', AddressController);
Stimulus.register('user-payments', UserPaymentsController);
Stimulus.register('outstanding-balance', OutstandingBalanceController);

/* 'data-confirm' dialog handler using event delegation */
document.addEventListener('click', (event) => {
  const element = event.target.closest('[data-confirm]');
  if (element) {
    if (!confirm(element.getAttribute('data-confirm'))) {
      event.preventDefault();
    }
  }
});
